
/// <reference path="typings/elearning.d.ts" />

import { getURLParamsArray } from './helpers/helperFunctions';

interface URLCheckerHandler {
    [index: string]: (value: string) => any;
}

export default class URLChecker {
    constructor(handlers: URLCheckerHandler = {}) {
        this.addHandlers(handlers)
            .init();
    }

    private addHandlers(handlers: URLCheckerHandler): URLChecker {
        Object.entries(handlers).forEach(([name, handler]) => this[name] = handler);
        return this;
    }

    private init(): URLChecker {
        const params = this.getURLParams();

        if (params['showloginoverlay'] == "1") {
            this.showLoginOverlay();
        }

        return this;
    }

    private getURLParams(): URLParams {
        const queries = getURLParamsArray(),
            params = {};

        queries.forEach((indexQuery: string) => {
            const indexPair = indexQuery.split('='),
                queryKey = decodeURIComponent(indexPair[0]).toLowerCase(),
                queryValue = decodeURIComponent(indexPair.length > 1 ? indexPair[1] : "");

            params[queryKey] = queryValue;
        });

        return params;
    }

    showLoginOverlay(): void {
        new ShowLogInOverlay();
    }
}

class ShowLogInOverlay {
    ajaxField: HTMLElement;

    constructor() {
        this.ajaxField = document.querySelector(".login-overlay[data-ajax-url]");
        if (this.ajaxField) {
            this.showOverlay()
        }
    }

    showOverlay() {
        const loginurl =this.ajaxField.getAttribute('data-ajax-url');
        window.Beiersdorf.openLayer(loginurl, 'login-overlay');
    }
}

